export enum EnvironmentTypeEnum {
    PRODUCTION = 'production',
    TEST_AND_DEVELOP = 'testAndDevelop',
}
